import * as ProductsActions from './../actions/products.actions';
import * as ProductsBusinessLogic from '@dch/products-business-logic';
import {
  Location,
  Pack,
  Product,
  TechnicalError,
} from '@dch/products-business-logic';

export interface ProductState {
  _embedded: any;
  installationAddresses: { [key: string]: Location };
  packs: { [key: string]: Pack };
  products: Array<Product>;
  isPending: boolean;
  error: TechnicalError;
  loaded: boolean;
  redirectedToDetails: boolean;
}

export const initialState: ProductState = {
  _embedded: null,
  installationAddresses: null,
  packs: null,
  products: null,
  isPending: false,
  loaded: false,
  error: null,
  redirectedToDetails: false
};

export const getEmbeddedErrors = (state: ProductState) =>
  state._embedded && state._embedded.errors;
export const getHasProductWithoutAddress = (state: ProductState) =>
  ProductsBusinessLogic.hasProductWithoutAddress(state.products);
export const getInstallationAddresses = (state: ProductState) =>
  state.installationAddresses;
export const getExtraServices = (state: ProductState) =>
  ProductsBusinessLogic.getExtraServicesReduced(state.products);
export const getPacks = (state: ProductState) =>
  ProductsBusinessLogic.getProductsInPacks(state.packs, state.products);
export const getOutOfPack = (state: ProductState) =>
  ProductsBusinessLogic.getProductsOutOfPacks(state.products);
export const getProducts = (state: ProductState) => state.products;
export const getTechnicalError = (state: ProductState) => state.error;
export const getFirstCoreProduct = (state: ProductState) => {
  const coreProducts = ProductsBusinessLogic.getCoreProducts(state.products);
  return coreProducts && coreProducts[0];
};
export const getPending = (state: ProductState) => state.isPending;
export const getRedirectedToDetails = (state: ProductState) =>
  state.redirectedToDetails;

export function reducer(
  state: ProductState = initialState,
  action: ProductsActions.Actions,
): ProductState {
  switch (action.type) {
    case ProductsActions.GET_PRODUCTS:
      return {
        ...state,
        isPending: true,
        error: null,
      };
    case ProductsActions.GET_PRODUCTS_SUCCESS:
      return {
        ...state,
        _embedded: action.payload._embedded,
        installationAddresses: action.payload.installationAddresses,
        packs: action.payload.packs,
        products: action.payload.products,
        isPending: false,
        loaded: true,
        error: null,
      };
    case ProductsActions.GET_PRODUCTS_FAILED:
      return {
        ...state,
        error: action.payload,
        isPending: false,
        loaded: true
      };
    case ProductsActions.GET_PRODUCTS_REDIRECTED_TO_DETAILS:
      return {
        ...state,
        redirectedToDetails: true,
      };
    default:
      return state;
  }
}
